// extracted by mini-css-extract-plugin
export default {"txt":"BombBombSendFormBody_txt__cewj7"};